import { MantineTheme, createStyles } from "@mantine/styles";

export const useStyle = createStyles((theme: MantineTheme) => ({
  buttonDiv: {
    display: "flex",
    flexDirection: "row",
    paddingLeft: "0px",
    gap: "30px",
  },
  // buttonWrapper:{
  //     paddingTop:'10px'
  // },
  stepContent: {
    padding: theme.spacing.md,
    backgroundColor: theme.white,
  },
  buttonWrapper: {
    marginTop: theme.spacing.md,
    display: "flex",
    justifyContent: "center",
  },
  errorSummary: {
    backgroundColor: "#ffe6e6",
    padding: theme.spacing.md,
    marginBottom: theme.spacing.md,
    border: "1px solid red",
    borderRadius: theme.radius.sm,
  },
  tabError: {
    borderBottom: "2px solid red",
    color: "red",
  },
  inputError: {
    border: `1px solid ${theme.colors.red[6]}`,
  },
  errorMessage: {
    color: theme.colors.red[6],
    fontSize: theme.fontSizes.sm,
    marginTop: theme.spacing.xs,
  },
}));
